import { render, staticRenderFns } from "./TemporaryPay.vue?vue&type=template&id=2f0bc2fb&scoped=true&"
import script from "./TemporaryPay.vue?vue&type=script&lang=js&"
export * from "./TemporaryPay.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryPay.vue?vue&type=style&index=0&id=2f0bc2fb&lang=scss&scoped=true&"
import style1 from "./TemporaryPay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0bc2fb",
  null
  
)

export default component.exports